import DesktopWrapper from "../../../../components/layout/desktop/desktop-wrapper"
import ActiveRequestsList from "./ActiveRequestsList"
import HistoryRequestsList from "./HistoryRequestlist"

const GiftCreditList = () => {
  return (
    <DesktopWrapper title='اعتبار من'>
      <ActiveRequestsList />
      <HistoryRequestsList />
    </DesktopWrapper>
  )
}

export default GiftCreditList
